import { useState, useEffect } from 'react';
import { formatNumber } from "src/MarketDataComponents/Helpers";
import { generateGuid } from 'src/Utils';

export default function Regions({region, regionCategory, formattedDate}) {
    const [showTable, setShowTable] = useState(false);
    const [headerTotals, setHeaderTotals] = useState({});

    useEffect(() => {
        let showTable = false;
        let headerTotals = {
            'Greater Europe': {
                fund: 0,
                category: 0,
                regions: {}
            },
            Americas: {
                fund: 0,
                category: 0,
                regions: {}
            },
            'Greater Asia': {
                fund: 0,
                category: 0,
                regions: {}
            }
        };

        region.map(reg => {
            regionCategory.map(cat => {
                if (reg.label === cat.label) {
                    if (headerTotals[reg.superRegion]) {
                        headerTotals[reg.superRegion].fund += reg.value;
                        headerTotals[cat.superRegion].category += cat.value;
    
                        headerTotals[reg.superRegion].regions[reg.label] = {
                            fund: reg.value,
                            category: cat.value
                        };
    
                        if (reg.value) {
                            showTable = true;
                        }
                    }
                }
            });
        });
        
        setShowTable(showTable);
        setHeaderTotals(headerTotals);
    }, []);

    const renderRows = () => {
        const rows = [];
        
        for (let header in headerTotals) {
            const section = headerTotals[header];

            rows.push(
                <tr key={generateGuid()}>
                    <td data-testid={`${(header.replace(/\s/g,'')).toLowerCase()}HeaderLabel`}><span className="font-weight-bold">{header}</span></td>
                    <td className="text-align-right font-weight-bold" data-testid={`${(header.replace(/\s/g,'')).toLowerCase()}HeaderFundValue`}>{formatNumber(section.fund, 2)}</td>
                    <td className="text-align-right font-weight-bold" data-testid={`${(header.replace(/\s/g,'')).toLowerCase()}HeaderCatValue`}>{formatNumber(section.category, 2)}</td>
                </tr>
            );

            for (let reg in section.regions) {
                const region = section.regions[reg];
                const id = (reg.replace(/\s/g,'')).toLowerCase();

                rows.push(
                    <tr key={generateGuid()}>
                        <td data-testid={`${id}Label`}>{reg}</td>
                        <td className="text-align-right" data-testid={`${id}FundValue`}>{formatNumber(region.fund, 2)}</td>
                        <td className="text-align-right" data-testid={`${id}CatValue`}>{formatNumber(region.category, 2)}</td>
                    </tr>
                );
            }
        }

        return rows;
    };

    return <div className="card z-depth-0 margin-0">
        {showTable ? <div className="card-content padding-top-0-sm padding-right-0-sm padding-bottom-30-sm padding-left-0-sm">
            <div className="ajb-grid-row">
                <span className="card-title float-left float-none-sm" data-testid="worldRegionsHeader">World regions %</span>
                {formattedDate ? <p className="h7 float-right float-none-sm" data-testid="worldRegionsDate">{formattedDate}</p> : null}
            </div>
            <div className="ajb-grid-row">
                <table className="data-table data-table--small data-table--scroll margin-0 highlight">
                    <thead>
                        <tr>
                            <th></th>
                            <th className="text-align-right" data-testid="worldRegionsFundTableHead">Fund</th>
                            <th className="text-align-right" data-testid="worldRegionsCatTableHead">Category</th>
                        </tr>
                    </thead>
                    <tbody>
                        {renderRows()}
                    </tbody>
                </table>
            </div>
        </div> : null}
    </div>
}